<div class="sticky z-40 bg-white pb-3" style="top: 64px;">
  <nav compact tuiSubheader class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
      <ng-container *ngFor="let item of breadcrumbs; let last = last">
        <ng-container *ngIf="last">
          <strong *tuiItem tuiFade>{{ item }}</strong>
        </ng-container>
        <ng-container *ngIf="!last">
          <button *tuiItem tuiLink type="button">{{ item }}</button>
        </ng-container>
      </ng-container>
    </tui-breadcrumbs>
  </nav>

  <div class="items-center flex justify-between mt-2 flex-wrap gap-3">
    <p class="text-[1.25rem] font-bold mt-[0.9rem] text-[#000000A6] m-0">Leaves</p>
    <div class="flex items-center gap-3 flex-wrap">
      <button [routerLink]="['/admin/leave/add-edit']" size="s" tuiButton type="button" appearance="secondary"
        style="border: 2px solid #e5e7ea; font-weight: 800" [appDisableUnlessPermission]="'LEAVE_CREATE'">
        Add New Leave
      </button>
      <button size="s" tuiButton type="button" appearance="flat" (click)="exportExcel()" [disabled]="!leaveData.length">
        Excel
      </button>
      <button size="s" tuiButton type="button" appearance="flat" (click)="exportPdf()" [disabled]="!leaveData.length">
        PDF
      </button>
    </div>
  </div>

  <section class="w-full mt-4">
    <div class="flex items-center space-x-4 mb-4 flex-wrap gap-y-3">
      <div class="w-[431px] max-w-full">
        <tui-textfield iconStart="@tui.search" tuiTextfieldSize="m">
          <input [(ngModel)]="filters.search" (keydown)="onEnter($event)" placeholder="Search nurse" tuiTextfield />
        </tui-textfield>
      </div>

      <div class="w-[140px]">
        <tui-combo-box tuiTextfieldSize="m" [stringify]="stringifyYear" [(ngModel)]="filters.year">
          Year
          <input tuiTextfieldLegacy placeholder="Year" [value]="stringifyYear(filters.year)" />
          <tui-data-list-wrapper *tuiDataList [items]="yearItems" [itemContent]="stringifyYear | tuiStringifyContent" />
        </tui-combo-box>
      </div>

      <div class="w-[180px]">
        <tui-combo-box tuiTextfieldSize="m" [stringify]="stringifyMonth" [(ngModel)]="filters.month">
          Month
          <input tuiTextfieldLegacy placeholder="Month" [value]="stringifyMonth(filters.month)" />
          <tui-data-list-wrapper *tuiDataList [items]="monthItems" [itemContent]="stringifyMonth | tuiStringifyContent" />
        </tui-combo-box>
      </div>

      <button (click)="pageIndex = 0; loadLeaves()" appearance="secondary" size="m" tuiButton type="button"
        style="border: 2px solid #e5e7ea; font-weight: 800">
        Search
      </button>
    </div>

    <div class="flex items-center justify-between w-full flex-wrap gap-3">
      <div class="flex items-center space-x-4">
        <p class="text-sm font-semibold text-[#26293C] my-0">
          Showing results for "{{ resultsLabel }}"
        </p>
        <button appearance="flat" iconStart="@tui.rotate-cw" size="xs" tuiButton type="reset" (click)="clearFilters()">
          Clear
        </button>
      </div>

      <!-- <div class="flex items-center space-x-2">
        <p class="text-sm font-medium text-[#191C30E5] my-0">Show Archived</p>
        <input title="Archived switch" tuiSwitch type="checkbox" [(ngModel)]="filters.archived"
          (change)="pageIndex = 0; loadLeaves()" />
      </div> -->
    </div>
  </section>
</div>

<div *ngIf="isLoading" class="h-[300px] mt-6">
  <tui-loader />
</div>

<div *ngIf="!isLoading" class="w-full mt-5">
  <table tuiTable [size]="size" class="w-full leave-table">
    <thead>
      <tr>
        <th tuiTh class="leave-th">Employment Number</th>
        <th tuiTh class="leave-th">Nurse Name</th>
        <th tuiTh class="leave-th">Nurse Type</th>
        <th tuiTh class="leave-th">Leave Type</th>
        <th tuiTh class="leave-th">Submitted Date</th>
        <th tuiTh class="leave-th">Leave Dates</th>
        <th tuiTh class="leave-th">Leave Days Count</th>
        <th tuiTh class="leave-th">
          <div style="display: flex; align-items: center; gap: 6px;">
            Reason
            <!-- Edit Icon -->
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              style="opacity: 0.6; cursor: pointer;">
              <path d="M12 20h9"></path>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
            </svg>
          </div>
        </th>
        <th tuiTh class="leave-th">Actions</th>
      </tr>
    </thead>
    <tbody tuiTbody>
      <tr *ngFor="let leave of leaveData">
        <td tuiTd class="leave-td">
          <div [tuiCell]="size">
            <p [routerLink]="nurseProfileLink(leave)" class="text-[#526ED3] text-sm cursor-pointer m-0">
              {{ employeeNumber(leave) }}
            </p>
          </div>
        </td>
        <td tuiTd class="leave-td">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm m-0">{{ nurseName(leave) }}</p>
          </div>
        </td>
        <td tuiTd class="leave-td">
          <span class="type-badge" [ngClass]="nurseTypeClass(leave)">
            {{ nurseType(leave) }}
          </span>
        </td>
        <td tuiTd class="leave-td">
          <span class="type-badge" [ngClass]="leaveTypeClass(leave.leaveType)">
            {{ leaveTypeLabel(leave.leaveType) }}
          </span>
        </td>
        <td tuiTd class="leave-td">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm m-0">
              {{ leave.submittedDate | date : "MMM d, y" }}
            </p>
          </div>
        </td>
        <td tuiTd class="leave-td">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm m-0">
              {{ leave.fromDate | date : "MMM d, y" }}
              –
              {{ leave.toDate | date : "MMM d, y" }}
            </p>
          </div>
        </td>
        <td tuiTd class="leave-td">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm m-0">{{ leave.dayCount }}</p>
          </div>
        </td>
        <td tuiTd class="leave-td">
          <tui-textfield tuiTextfieldSize="s" class="reason-input">
            <input tuiTextfield [(ngModel)]="leave.reason" (blur)="saveReason(leave)"
              placeholder="Click here to add remarks" [appDisableUnlessPermission]="'LEAVE_UPDATE'" />
          </tui-textfield>
        </td>
        <td tuiTd class="leave-td">
          <span class="flex items-center gap-2">
            <button [routerLink]="['/admin/leave/add-edit', leave._id]" type="button" class="action-link"
              [appDisableUnlessPermission]="'LEAVE_UPDATE'">
              Edit
            </button>
            <button appearance="action" iconStart="@tui.ellipsis" size="xs" tuiIconButton type="button"
              [tuiAppearanceState]="openMap[leave._id] ? 'hover' : null" [tuiDropdown]="menu"
              [(tuiDropdownOpen)]="openMap[leave._id]" (click)="toggleDropdown(leave._id)"
              [appDisableUnlessPermission]="'LEAVE_DELETE'"></button>
            <ng-template #menu>
              <tui-data-list tuiDataListDropdownManager size="s">
                <button tuiOption type="button" class="text-red-600" (click)="deleteLeave(leave)">
                  Delete
                </button>
              </tui-data-list>
            </ng-template>
          </span>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="!leaveData.length" class="py-10 text-center text-[#6B6D80]">
    No leave records found.
  </div>

  <div class="flex justify-end mt-5" *ngIf="total > 0">
    <tui-pagination [index]="pageIndex" [length]="getPageCount()" (indexChange)="onPageChange($event)"></tui-pagination>
  </div>
</div>

<ng-template [tuiDialogOptions]="{ label: 'Delete leave record', size: 's' }" [(tuiDialog)]="confirmDeleteDialogOpen">
  <p class="text-sm mb-4">Are you sure you want to delete this leave record?</p>
  <div class="flex justify-end gap-2 flex-wrap">
    <button tuiButton type="button" size="s" appearance="secondary" (click)="onConfirmDeleteCancel()">
      Cancel
    </button>
    <button tuiButton type="button" size="s" appearance="destructive" (click)="onConfirmDeleteYes()">
      Yes
    </button>
  </div>
</ng-template>